import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import CollectionChannelCard from '@/v2/my-page/collection-channel/collection-channel-card/collection-channel-card.vue';
import type { AccountChannel, AgentChannel } from '@/shared/model/collection-channel.model';

@Component({
  computed: {},
  methods: {},
  components: {
    'collection-channel-card': CollectionChannelCard,
  },
})
export default class CollectionChannelViews extends Vue {
  @Prop({ required: true }) public readonly accountChannels!: AccountChannel[];

  @Emit('account:change') changeAccount(acc: AccountChannel) {}

  @Emit('account:unlink') unlinkAccount(acc: AccountChannel) {}

  @Emit('agent:update') updateAgent(acc: AccountChannel, agent: AgentChannel) {}
}
